module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/tipo-impresion/tipo-impresion.component.scss
// module id = ./src/app/productos/tipo-impresion/tipo-impresion.component.scss
// module chunks = main